(function(){
  var LEAD_URL = 'https://whatsapp.bigstudio.cl/agenda-lead';
  function origen(){
    try {
      var q = new URLSearchParams(location.search), p = [];
      ['utm_source','utm_medium','utm_campaign'].forEach(function(k){ if(q.get(k)) p.push(q.get(k)); });
      if(q.get('origen')) p.push('cta ' + q.get('origen'));
      if(q.get('gclid')) p.push('gclid');
      if(q.get('fbclid')) p.push('fbclid');
      var ref = document.referrer ? new URL(document.referrer).hostname : '';
      if(ref && ref.indexOf('bigstudio.cl') === -1) p.push('ref ' + ref);
      if(!q.get('utm_source') && !q.get('gclid') && !q.get('fbclid') && !(ref && ref.indexOf('bigstudio.cl') === -1)){
        var o1 = ''; try { o1 = sessionStorage.getItem('bs_origen1') || ''; } catch(err){}
        if(o1) p.push('llegó por ' + o1);
      }
      return p.join(' / ');
    } catch(err){ return ''; }
  }
  function telCL(v){
    var d = String(v || '').replace(/\D/g, '');
    if(d.indexOf('56') === 0) d = d.slice(2);
    return /^9\d{8}$/.test(d) ? '+56' + d : String(v || '').trim();
  }
  function normPlan(v){
    return String(v || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().replace(/^plan[\s_-]+/, '').replace(/[_-]+/g, ' ').replace(/\s+/g, ' ').trim();
  }
  function rutaDeOrigen(o){
    o = String(o || '').toLowerCase();
    if(!o) return '';
    if(/^soporte/.test(o)) return 'soporte';
    if(/^(facturacion|integracion)/.test(o)) return 'facturacion';
    if(/^publicidad/.test(o)) return 'publicidad';
    if(/^(migrar|rediseno)/.test(o)) return 'migracion';
    if(/^(diseno|agencia|shopify-b2b|b2b|tienda|precios|pagina-imagen)(-|$)/.test(o)) return 'tienda';
    return '';
  }
  function ufTxt(uf){ return String(uf).replace('.', ','); }

  function texto(el, valor){
    if(!el) return;
    if(!el.firstChild) el.appendChild(document.createTextNode(''));
    el.firstChild.nodeValue = String(valor);
  }
  function init(root){
    if(root.dataset.bsAgendaLista) return;
    root.dataset.bsAgendaLista = 'true';
    var d = root.dataset;
    var WA = d.wa || '56932141504';
    var CAL = d.cal || '';
    var READY = d.ready || 'Ver disponibilidad y agendar';
    var LOCKED = d.locked || 'Confirma plan, presupuesto y datos';
    var CONFIRM = d.confirm || '';
    var NOTE = d.note || '';
    var STEP_PLAN = d.stepPlan || '';
    var sel = null, ruta = null, salida = false, mostrarErrores = false;
    var rutas = root.querySelectorAll('.bs-agf__ruta');
    var plans = root.querySelectorAll('.bs-agf__plan');
    var preguntas = root.querySelectorAll('.bs-agf__q');
    var ufEl = root.querySelector('[data-bs-agf-uf]');
    var ufNota = root.querySelector('[data-bs-agf-uf-nota]');
    var clpEl = root.querySelector('.bs-agf__price-clp');
    var rowsEl = root.querySelector('.bs-agf__price-rows');
    var priceTextEl = root.querySelector('.bs-agf__price-text');
    var noteEl = root.querySelector('.bs-agf__price-note');
    var confirmTxt = root.querySelector('.js-confirm-txt');
    var stepPlanEl = root.querySelector('.js-step-plan');
    var plansBox = root.querySelector('.bs-agf__plans');
    var tiendaReq = root.querySelector('.js-tienda-req');
    var ok = root.querySelector('.js-ok');
    var cta = root.querySelector('.js-cta');
    var ctaTxt = root.querySelector('.js-cta-txt');
    var nombreEl = root.querySelector('.js-nombre');
    var emailEl = root.querySelector('.js-email');
    var tiendaEl = root.querySelector('.js-tienda');
    var LEAD = d.lead || LEAD_URL;
    var ultimo = null, firmaIniciada = '', agendadaEnviada = false;
    if(rutas.length) root.classList.add('js-rutas-on');

    function rutaKey(){ return ruta ? ruta.dataset.ruta : ''; }
    function enRuta(p){
      if(!ruta) return true;
      return (p.dataset.rutas || 'tienda,migracion').split(',').indexOf(rutaKey()) > -1;
    }
    function tiendaObligatoria(){ return !!(ruta && ruta.dataset.store); }
    function preguntasVisibles(){
      var out = [];
      preguntas.forEach(function(q){ if(!q.hidden) out.push(q); });
      return out;
    }

    function precioNodo(){
      if(!sel || !sel.dataset.slug) return null;
      var caja = root.querySelector('[data-bs-plan-precio="' + sel.dataset.slug + '"]');
      return caja && caja.querySelector('[data-bs-precio]');
    }
    function valorPlan(){ return Number(precioNodo()?.dataset.valorClp || 0); }
    function paint(){
      if(!sel || !sel.dataset || !sel.dataset.uf) return;
      var precio = precioNodo(), mes = sel.dataset.periodo === 'mensual' ? ' al mes' : '';
      texto(ufEl, ufTxt(sel.dataset.uf) + ' UF ');
      texto(ufNota, '+ IVA' + mes);
      var visible = precio?.querySelector('[data-bs-precio-valor]');
      texto(clpEl, (visible ? visible.firstChild.nodeValue : '') + ' + IVA' + mes + (precio?.dataset.bsUfFuente === 'respaldo' ? ' (aproximado)' : ''));
      clpEl.dataset.valorClp = String(valorPlan());
    }
    function campoError(el, invalido){
      if(el) el.setAttribute('aria-invalid', mostrarErrores && invalido ? 'true' : 'false');
    }
    function refresh(){
      var n = nombreEl.value.trim(), e = emailEl.value.trim();
      var faltan = false;
      preguntasVisibles().forEach(function(q){
        var s = q.querySelector('.js-q');
        var invalido = !!(q.dataset.required && s && !s.value);
        campoError(s, invalido);
        if(invalido) faltan = true;
      });
      var faltaTienda = tiendaObligatoria() && !(tiendaEl && tiendaEl.value.trim());
      campoError(tiendaEl, faltaTienda);
      if(faltaTienda) faltan = true;
      if(rutas.length && !ruta) faltan = true;
      var emailValido = /.+@.+\..+/.test(e);
      campoError(nombreEl, !n); campoError(emailEl, !emailValido);
      var v = !!(sel && ok.checked && n && emailValido && !faltan);
      cta.classList.toggle('is-on', !!v);
      texto(ctaTxt, v ? READY : LOCKED);
      cta.setAttribute('aria-disabled', v ? 'false' : 'true');
      var error = root.querySelector('.bs-agf__error');
      if(error) error.hidden = !mostrarErrores || v;
      root.dataset.sel = sel && sel.dataset ? (sel.dataset.name || '') : '';
      return v;
    }
    var precios = root.querySelectorAll('[data-bs-precio]');
    var observadorPrecios = new MutationObserver(function(){ paint(); });
    precios.forEach(function(precio){ observadorPrecios.observe(precio, { attributes: true, attributeFilter: ['data-valor-clp', 'data-bs-uf-fuente'] }); });
    root.addEventListener('bs:agenda:desmontar', function(){ observadorPrecios.disconnect(); }, { once: true });

    function elegirPlan(b){
      plans.forEach(function(x){ x.classList.remove('is-sel'); x.setAttribute('aria-pressed', 'false'); });
      b.classList.add('is-sel'); b.setAttribute('aria-pressed', 'true'); sel = b; paint(); refresh();
    }
    plans.forEach(function(b){ b.addEventListener('click', function(){ elegirPlan(b); }); });
    function revisarSalida(){
      salida = false;
      preguntasVisibles().forEach(function(q){
        var s = q.querySelector('.js-q'), box = q.querySelector('.bs-agf__salida');
        var activa = !!(q.dataset.salida && s && s.value === q.dataset.salida);
        if(box) box.hidden = !activa;
        if(activa) salida = true;
      });
    }
    preguntas.forEach(function(q){
      var s = q.querySelector('.js-q');
      if(s) s.addEventListener('change', function(){ revisarSalida(); refresh(); });
    });

    function elegirRuta(btn, planPreferido){
      ruta = btn;
      rutas.forEach(function(r){ var on = r === btn; r.classList.toggle('is-sel', on); r.setAttribute('aria-checked', on ? 'true' : 'false'); });
      root.classList.add('has-ruta');
      var visibles = [];
      plans.forEach(function(p){ var si = enRuta(p); p.hidden = !si; if(si) visibles.push(p); });
      preguntas.forEach(function(q){ q.hidden = q.dataset.ruta !== rutaKey(); });
      revisarSalida();
      texto(stepPlanEl, btn.dataset.stepPlan || STEP_PLAN);
      texto(confirmTxt, btn.dataset.confirm || CONFIRM);
      texto(noteEl, btn.dataset.note || NOTE);
      if(tiendaReq) tiendaReq.hidden = !tiendaObligatoria();
      if(ok) ok.checked = false;
      plans.forEach(function(x){ x.classList.remove('is-sel'); x.setAttribute('aria-pressed', 'false'); });
      sel = null;
      if(visibles.length){
        if(plansBox) plansBox.hidden = false;
        if(rowsEl) rowsEl.hidden = false;
        if(priceTextEl) priceTextEl.hidden = true;
        texto(ufEl, 'Elige un plan'); texto(ufNota, '');
        texto(clpEl, 'Según el plan que elijas'); clpEl.dataset.valorClp = '0';
        var pref = planPreferido && visibles.indexOf(planPreferido) > -1 ? planPreferido : visibles[0];
        elegirPlan(pref);
      } else {
        if(plansBox) plansBox.hidden = true;
        if(rowsEl) rowsEl.hidden = true;
        if(priceTextEl){ texto(priceTextEl, btn.dataset.priceText || ''); priceTextEl.hidden = !btn.dataset.priceText; }
        sel = rutaKey() === 'publicidad' && btn.dataset.planName && btn.dataset.priceText ? { dataset: { name: btn.dataset.planName, uf: '', url: CAL, periodo: '' } } : null;
        clpEl.dataset.valorClp = '0';
        refresh();
      }
    }
    rutas.forEach(function(r){ r.addEventListener('click', function(){
      elegirRuta(r, null);
      if(window.innerWidth < 760 && stepPlanEl){
        var quieto = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        stepPlanEl.parentNode.scrollIntoView({ behavior: quieto ? 'auto' : 'smooth', block: 'start' });
      }
    }); });

    rutas.forEach(function(r, indice){ r.addEventListener('keydown', function(e){
      var movimiento = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[e.key];
      if(!movimiento && e.key !== 'Home' && e.key !== 'End') return;
      e.preventDefault();
      var destino = e.key === 'Home' ? 0 : e.key === 'End' ? rutas.length - 1 : (indice + movimiento + rutas.length) % rutas.length;
      rutas[destino].focus(); elegirRuta(rutas[destino], null);
    }); });

    if(ok) ok.addEventListener('change', refresh);
    [nombreEl, emailEl, tiendaEl].forEach(function(el){ if(el) el.addEventListener('input', refresh); });

    function detalle(){
      var partes = [];
      preguntasVisibles().forEach(function(q){
        var s = q.querySelector('.js-q');
        if(s && s.value) partes.push((s.dataset.label || '').replace(/[¿?]/g, '').trim() + ': ' + s.value);
      });
      if(salida) partes.unshift('Fuera de perfil');
      return partes.join(' · ');
    }
    function ctx(){
      var g = function(c){ var el = root.querySelector(c); return el ? el.value.trim() : ''; };
      var uf = sel && sel.dataset.uf ? sel.dataset.uf : '';
      var clp = uf ? valorPlan() : 0;
      return { nombre:g('.js-nombre'), email:g('.js-email'), wsp:g('.js-wsp'), tienda:g('.js-tienda'),
               cuando:g('.js-cuando'), plan: sel ? sel.dataset.name : '', uf:uf, clp:clp,
               url: sel && sel.dataset.url ? sel.dataset.url : CAL,
               ruta: rutaKey(), periodo: sel && sel.dataset.periodo === 'mensual' ? 'mensual' : '', detalle: detalle() };
    }
    function enviar(estado, c, extra){
      if(!LEAD || !c || !c.email) return;
      var datos = { estado: estado, nombre: c.nombre, email: c.email, wsp: c.wsp, tienda: c.tienda, cuando: c.cuando,
                    plan: c.plan, uf: c.uf, clp: c.clp, confirmo: c.confirmo, origen: origen(),
                    ruta: c.ruta, periodo: c.periodo, detalle: c.detalle };
      if(extra){ for(var k in extra){ datos[k] = extra[k]; } }
      try {
        fetch(LEAD, { method:'POST', mode:'cors', credentials:'omit', keepalive:true,
          headers:{ 'Content-Type':'text/plain;charset=UTF-8' }, body: JSON.stringify(datos) }).catch(function(){});
      } catch(err){}
    }

    if(cta) cta.addEventListener('click', function(){
      mostrarErrores = true;
      if(!refresh()) { root.querySelector('[aria-invalid="true"]')?.focus(); return; }
      paint();
      root.dataset.bsAgendaIniciada = 'true';
      if(typeof window.fbq === 'function') window.fbq('track', 'Lead', { content_name: sel.dataset.name, content_category: 'Agenda', value: valorPlan(), currency: 'CLP' });
      var c = ctx();
      c.confirmo = !!(ok && ok.checked);
      ultimo = c; agendadaEnviada = false;
      var firma = [c.email, c.nombre, c.plan, c.wsp, c.tienda, c.cuando, c.ruta, c.detalle].join('|');
      if(firma !== firmaIniciada){ firmaIniciada = firma; enviar('iniciada', c); }
      var url = c.url + (c.url.indexOf('?') > -1 ? '&' : '?') + 'hide_gdpr_banner=1'
        + '&name=' + encodeURIComponent(c.nombre) + '&email=' + encodeURIComponent(c.email);
      if(c.wsp) url += '&a1=' + encodeURIComponent(telCL(c.wsp));
      var estadoCalendario = root.querySelector('[data-bs-calendario-cargando]');
      if(estadoCalendario) estadoCalendario.hidden = false;
      if(window.Calendly){ Calendly.initPopupWidget({url:url}); }
      else { window.open(url, '_blank', 'noopener'); if(estadoCalendario) estadoCalendario.hidden = true; }
    });
    window.addEventListener('message', function(e){
      if(e.origin !== 'https://calendly.com' || !e.data) return;
      if(/^calendly\./.test(e.data.event || '')) { var estado = root.querySelector('[data-bs-calendario-cargando]'); if(estado) estado.hidden = true; }
      if(e.data.event !== 'calendly.event_scheduled') return;
      if(!ultimo || agendadaEnviada) return;
      agendadaEnviada = true;
      var p = e.data.payload || {};
      enviar('agendada', ultimo, { invitee: p.invitee && p.invitee.uri });
    });

    root.querySelectorAll('.js-wa').forEach(function(wa){
      wa.addEventListener('click', function(e){
        var c = ctx();
        var m = (ruta && ruta.dataset.wa) ? ruta.dataset.wa : '¡Hola BigStudio! Estoy viendo los planes';
        if(c.plan && c.uf) m += ' (' + c.plan + ', ' + ufTxt(c.uf) + ' UF + IVA' + (c.periodo === 'mensual' ? ' al mes' : '') + ')';
        m += ' y quiero más info antes de agendar.';
        wa.href = 'https://wa.me/' + WA + '?text=' + encodeURIComponent(m);
      });
    });
    function planDeUrl(lista){
      try {
        var q = new URLSearchParams(location.search);
        var v = normPlan(q.get('plan') || q.get('utm_content'));
        if(!v) return null;
        for(var i = 0; i < lista.length; i++){
          var n = normPlan(lista[i].dataset.name);
          if(n === v || n.slice(-(v.length + 1)) === ' ' + v) return lista[i];
        }
      } catch(err){}
      return null;
    }

    if(!rutas.length){
      if(plans.length){ (planDeUrl(plans) || plans[0]).click(); }
      return;
    }
    var q0 = new URLSearchParams(location.search);
    var clave = (q0.get('ruta') || '').toLowerCase();
    if(!clave) clave = rutaDeOrigen(q0.get('origen'));
    if(!clave && (q0.get('plan') || q0.get('utm_content'))){
      var elegidoUrl = planDeUrl(Array.from(plans));
      if(elegidoUrl) clave = (elegidoUrl.dataset.rutas || '').split(',')[0];
    }
    var plataforma = normPlan(q0.get('plataforma'));
    var preguntaPlataforma = root.querySelector('[data-question="q_mig_plataforma"] .js-q');
    if(plataforma && preguntaPlataforma) Array.from(preguntaPlataforma.options).forEach(function(op){
      if(normPlan(op.value) === plataforma) preguntaPlataforma.value = op.value;
    });
    var inicial = null;
    rutas.forEach(function(r){ if(r.dataset.ruta === clave) inicial = r; });
    if(inicial){
      var lista = [];
      plans.forEach(function(p){ if((p.dataset.rutas || 'tienda,migracion').split(',').indexOf(clave) > -1) lista.push(p); });
      elegirRuta(inicial, planDeUrl(lista));
    } else {
      refresh();
    }
  }
  function go(){ document.querySelectorAll('.bs-agf').forEach(init); }
  if(document.readyState !== 'loading'){ go(); } else { document.addEventListener('DOMContentLoaded', go); }
  document.addEventListener('shopify:section:load', go);
  document.addEventListener('shopify:section:unload', function(e){ e.target.querySelectorAll('.bs-agf').forEach(function(root){ root.dispatchEvent(new Event('bs:agenda:desmontar')); }); });
})();

(function () {
  'use strict';

  var PIXEL_ID = '595968475232736';
  if (!document.querySelector('.bs-agf')) return;

  !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
  n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
  n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
  t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}
  (window,document,'script','https://connect.facebook.net/en_US/fbevents.js');

  if(!window.bsMetaAgendaInicializado){ fbq('init', PIXEL_ID); window.bsMetaAgendaInicializado = true; }

  function datosPlan() {
    var plan = document.querySelector('.bs-agf__plan.is-sel');
    var clpEl = document.querySelector('.bs-agf__price-clp');
    var clp = Number(clpEl?.dataset.valorClp || 0);
    var raiz = document.querySelector('.bs-agf');
    return {
      content_name: plan ? (plan.getAttribute('data-name') || '') : ((raiz && raiz.dataset.sel) || ''),
      content_category: 'Agenda',
      value: clp || 0,
      currency: 'CLP'
    };
  }

  var yaReservo = false;
  window.addEventListener('message', function (e) {
    if (e.origin !== 'https://calendly.com') return;
    var data = e.data;
    if (!data || data.event !== 'calendly.event_scheduled') return;
    if (yaReservo || document.querySelector('.bs-agf')?.dataset.bsAgendaIniciada !== 'true') return;
    yaReservo = true;
    var p = data.payload || {};
    var id = ((p.invitee && p.invitee.uri) || '').split('/').pop();
    try { if(id && localStorage.getItem('bs_sched_' + id)) return; if(id) localStorage.setItem('bs_sched_' + id, String(Date.now())); } catch (err) {}
    var datos = datosPlan();
    if (id) { fbq('track', 'Schedule', datos, { eventID: id }); }
    else { fbq('track', 'Schedule', datos); }
    if (typeof window.gtag === 'function') {
      var g = { content_name: datos.content_name };
      if (id) g.transaction_id = id;
      if (datos.value) { g.value = datos.value; g.currency = 'CLP'; }
      window.gtag('event', 'invitee_meeting_scheduled', g);
    }
  });

})();
